module.exports = __webpack_public_path__ + "static/fonts/NanumGothic_seB.7437d86.ttf";


//////////////////
// WEBPACK FOOTER
// ./static/fonts/NanumGothic_seB.ttf
// module id = 5nK7
// module chunks = 241